const coTimeZones = ['America/Bogota'].map((value) => ({
  label: value,
  value: value,
}));

export default coTimeZones;
